import { render, staticRenderFns } from "./AddPassengerDiscounts.vue?vue&type=template&id=9d693c90&"
import script from "./AddPassengerDiscounts.vue?vue&type=script&lang=js&"
export * from "./AddPassengerDiscounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports